import React from "react";
import {FaEdit, FaPhone, FaTrash} from "react-icons/fa";

function ProjectTable({ projects, onEdit, onAssignPhoneNumber, onDelete }) {
    return (
        <table className="app-table">
            <thead>
            <tr>
                <th>Name</th>
                <th>Is Active</th>
                <th>Edit</th>
                <th>Assign Phones</th>
                <th>Delete</th>
            </tr>
            </thead>
            <tbody>
            {projects.map((project) => (
                <tr key={project.id}>
                    <td>{project.name}</td>
                    <td>{project.isActive ? '✔️ Yes' : '❌ No'}</td>
                    <td>
                        {project.isActive && (
                            <FaEdit className="edit-icon" onClick={() => onEdit(project)}/>
                        )}
                    </td>
                    <td>
                        {project.isActive && (
                            <FaPhone className="phone-icon" onClick={() => onAssignPhoneNumber(project)}/>
                        )}
                    </td>
                    <td>
                        {project.isActive ? (
                            <FaTrash className="delete-icon" onClick={() => onDelete(project.id)}/>
                        ) : (" ")
                        }
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
    );
}

export default ProjectTable;
